import { useSelector } from 'react-redux';
import { isLoggedIn as isLoggedInSelector } from '../selectors/AuthenticationSelectors';

export const useIsLoggedIn = () => useSelector(isLoggedInSelector);
